import { setBaseUrl } from '../src/config/env'
import { Domain } from '@com.capgemini.cn/crbr-api-server'
// import { setUrl } from '@/api/api'
const urlData = {
  'cpmcust.crbeverage.com': 'pro', // prod
  'cpmcust-uat.crbeverage.com': 'uat', // uat
  'fat': 'fat',
  'sit': 'fat'
}

export const requestRemoteIp = () => { // 动态获取
  return new Promise((resolve, reject) => {
    Domain.getEnvUrl('cpmUrl', urlData, 'wechat-cust', true).then(res => {
      if (res.data) {
        // if (res.data['server-id']) {
        //   setUrl(res.data['server-id'])
        // }
        res.data['wechat-cust'] ? setBaseUrl(res.data['wechat-cust']) : setBaseUrl('http://cpmapi-uat.crbeverage.com') // dev
        resolve()
      }
    }).catch(err => {
      console.log(err)
      // alert(err.msg)
    })
  })
}



// WEBPACK FOOTER //
// ./src/doman.js